import { ReactNode } from "react";

import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
} from "./Tooltip";

export interface TextTooltipProps {
  children: ReactNode;
  content: string;
  asChild?: boolean;
}

export const TextTooltip = ({
  children,
  content,
  asChild = false,
}: TextTooltipProps) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger tabIndex={-1} asChild={asChild}>
        {children}
      </TooltipTrigger>
      <TooltipContent>
        <p>{content}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
